import { render, staticRenderFns } from "./ProjectHoursTags.vue?vue&type=template&id=0f5a02a0&scoped=true&"
import script from "./ProjectHoursTags.vue?vue&type=script&lang=js&"
export * from "./ProjectHoursTags.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHoursTags.vue?vue&type=style&index=0&id=0f5a02a0&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a02a0",
  null
  
)

export default component.exports